<div class="success" *ngIf="df.published as pub">
  <df-icon name="check" [size]="22"></df-icon>
  <div>
    <b>Published pack {{ pub.id }}</b>
    <div class="hint">{{ pub.n }} documents · {{ pub.at }}</div>
  </div>
  <span style="flex:1"></span>
  <button type="button" class="btn sm" (click)="exportCsv()"><df-icon name="dl" [size]="14"></df-icon>Export CSV</button>
  <button type="button" class="btn sm pri to-pbl" (click)="df.go(6)">Review the backlog (PBLs)</button>
  <button type="button" class="btn sm new-search" (click)="startNew()">Start a new search</button>
</div>

<div class="step-nav" style="display:flex;margin-top:18px" *ngIf="df.published">
  <button type="button" class="btn back-btn" (click)="df.go(4)">Back</button>
</div>

<div class="pub-grid">
  <section class="card pad">
    <h3 style="margin:0 0 4px;color:var(--navy);font-size:16px">Explore input pack</h3>
    <p class="hint" style="margin:0 0 16px">{{ included.length }} documents confirmed as relevant, grouped by type.</p>

    <div class="tbl-scroll"><table class="sum-tbl">
      <thead><tr><th>Document type</th><th style="text-align:center">As-Is (ECC)</th><th style="text-align:center">To-Be (S/4HANA)</th></tr></thead>
      <tbody>
        <tr *ngFor="let t of inputTypes">
          <td><span [style.background]="docTypes[t].color" style="display:inline-block;width:8px;height:8px;border-radius:2px;margin-right:8px"></span>{{ docTypes[t].long || docTypes[t].short }}</td>
          <ng-container *ngFor="let l of landscapes">
            <td class="na" *ngIf="cellCount(t, l) === null">Not applicable</td>
            <td class="c" *ngIf="cellCount(t, l) !== null" [style.color]="cellCount(t, l) === 0 ? '#B25400' : null" [style.font-weight]="cellCount(t, l) === 0 ? 700 : null">{{ cellCount(t, l) }}</td>
          </ng-container>
        </tr>
      </tbody>
    </table></div>

    <div class="pack-list">
      <ng-container *ngFor="let g of groups; trackBy: trackByType">
        <h4>
          <span [style.background]="docTypes[g.type].color" style="width:4px;height:16px;border-radius:2px"></span>
          {{ docTypes[g.type].long || docTypes[g.type].short }} <span class="muted" style="font-weight:500">({{ g.docs.length }})</span>
        </h4>
        <ul>
          <li *ngFor="let d of g.docs">
            <df-file-badge class="sm" [ext]="d.ext"></df-file-badge>
            <button type="button" class="link" style="color:var(--ink);font-weight:500;text-align:left" (click)="open(d.id)">{{ d.name }}</button>
            <span class="sp"></span>
            <span class="pill" [ngClass]="d.land">{{ d.land === 'asis' ? 'As-Is' : 'To-Be' }}</span>
          </li>
        </ul>
      </ng-container>
    </div>
  </section>

  <aside class="stack">
    <section class="card pad">
      <h3 style="margin:0 0 4px;color:var(--navy);font-size:15px">Publish</h3>
      <div class="form">
        <div class="full"><label for="pk-n">Pack name</label><input id="pk-n" class="fld" [(ngModel)]="packName" [placeholder]="df.query"></div>
        <div class="full"><label for="pk-note">Note for the workstream <small>(optional)</small></label>
          <textarea id="pk-note" class="fld" [(ngModel)]="packNote" placeholder="e.g. The To-Be BPD for LSC-310 is still being drafted"></textarea></div>
      </div>
      <div style="display:flex;gap:8px;margin-top:14px;flex-wrap:wrap">
        <button *ngIf="df.published" type="button" class="btn zip-btn" [disabled]="pack.busy" (click)="downloadZip()">
          <df-icon name="down" [size]="15"></df-icon>{{ pack.busy ? 'Preparing ZIP…' : 'Download ZIP again' }}
        </button>
        <button type="button" class="btn pri publish-btn" [disabled]="!!df.published || pack.busy || !included.length" (click)="publish()">
          <df-icon name="up" [size]="15"></df-icon>{{ pack.busy ? 'Preparing ZIP…' : df.published ? 'Published' : 'Publish pack (ZIP)' }}
        </button>
        <button type="button" class="btn csv-btn" (click)="exportCsv()"><df-icon name="dl" [size]="15"></df-icon>Export CSV</button>
        <button type="button" class="btn copy-btn" (click)="copyLinks()"><df-icon name="link" [size]="15"></df-icon>Copy links</button>
      </div>
    </section>

    <section class="card pad">
      <h3 style="margin:0 0 10px;color:var(--navy);font-size:15px">Feedback sent with this pack</h3>
      <div class="tally">
        <div><b class="t-inc">{{ included.length }}</b><span>relevant</span></div>
        <div><b class="t-exc">{{ df.excluded().length }}</b><span>irrelevant</span></div>
        <div><b class="t-miss">{{ df.missing.length }}</b><span>missed</span></div>
      </div>
      <ng-container *ngIf="df.reasonCounts() as rc">
        <ng-container *ngIf="rc.length">
          <p class="lbl" style="margin-top:14px">Reasons for irrelevance</p>
          <div *ngFor="let r of rc" style="display:flex;justify-content:space-between;font-size:12.5px;padding:3px 0"><span>{{ r.reason }}</span><b>{{ r.n }}</b></div>
        </ng-container>
      </ng-container>
      <p class="hint" style="margin:12px 0 0">Reviewed{{ reviewer ? ' by ' + reviewer : '' }} · {{ today | date: 'dd MMM yyyy' }}</p>
    </section>
  </aside>
</div>
